import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

// 品牌设备
var swiper1 = new Swiper(".section1 .sec1-swiper .mySwiper", {
  speed: 600,
  spaceBetween: 30,
  pagination: {// 分页
    el: ".section1 .sec1-swiper .swiper-pagination",
    clickable: true,
  },
  navigation: {//按钮
    nextEl: ".section1 .sec1-swiper .swiper-button-next",
    prevEl: ".section1 .sec1-swiper .swiper-button-prev",
  },
  on:{
    init: function(swiper){
      $('.section1 .tab-cont .tab>div').eq(this.realIndex).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section1 .tab-cont .tab>div').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  }
})
$('.section1 .tab-cont .tab>div').hover(function(){
  let index = $(this).index()
  swiper1.slideTo(index)
})


// 产品应用
var swiper2 = new Swiper(".section2 .sec2-swiper .mySwiper", {
  speed: 600,
  effect : 'fade',
  autoplay: {
    delay: 5000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  on:{
    init: function(swiper){
      $('.section2 .tab>div').eq(this.realIndex).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section2 .tab>div').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  }
})
$('.section2 .tab>div').hover(function(){
  let index = $(this).index()
  swiper2.slideTo(index)
})

// 查看更多
var clickNum = 0
var initshowliNum = 8
var showstep = 8
var totalli = $('.section2 .list li').length

if (totalli <= initshowliNum) {
  $('.section2 .more').hide()
}

$('.section2 .more .common-more').on('click', function () {
  clickNum += 1
  if (initshowliNum + showstep * clickNum < totalli) {
    for (let i = 0; i < showstep; i++) {
      $('.section2 .list li').eq(initshowliNum + (clickNum - 1) * showstep + i).show()
    }
  } else {
    for (let i = 0; i < totalli - clickNum * showstep; i++) {
      $('.section2 .list li').eq(initshowliNum + (clickNum - 1) * showstep + i).show()
    }
    $('.section2 .more').hide()
  }
})

// 主要客户
var swiper3 = new Swiper(".section3 .contSwiper", {
  speed: 600,
  autoHeight: true,
  allowTouchMove: false,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  on:{
    init: function(swiper){
      $('.section3 .tab>div').eq(this.realIndex).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section3 .tab>div').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  }
})
$('.section3 .tab>div').hover(function(){
  let index = $(this).index()
  swiper3.slideTo(index)
})

var swiper4 = new Swiper(".section3 .chanchang .mySwiper", {
  speed: 400,
  allowTouchMove: false,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  on:{
    init: function(swiper){
      $('.section3 .chanchang .cc-tab>div').eq(this.realIndex).addClass('active')
      $('.section3 .map ul li').eq(this.realIndex).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section3 .chanchang .cc-tab>div').eq(this.realIndex).addClass('active').siblings().removeClass('active')
      $('.section3 .map ul li').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  }
})
$('.section3 .chanchang .cc-tab>div').hover(function(){
  let index = $(this).index()
  swiper4.slideTo(index)
})
$('.section3 .map ul li').hover(function(){
  let index = $(this).index()
  swiper4.slideTo(index)
})

